
export const config={
  //apiUrl:"http://localhost/openai",
  //apiUrl:"http://openai.s4",
  apiUrl:"https://oaigkridc.duckdns.org",
}
